import axios from 'axios';
import { authActions } from 'store/auth';
import store from 'store/index';
import { getBuildVersion, setBuildUpdateFlag, setBuildVersion } from './api-version';

/* -------------------------------------------------------------------------------------------------
 * Axios instance for making requests
 * -----------------------------------------------------------------------------------------------*/

const http = axios.create();

/* -------------------------------------------------------------------------------------------------
 * Request interceptor for adding token
 * -----------------------------------------------------------------------------------------------*/

http.interceptors.request.use((config) => {
    const token = store.getState().auth.token;

    config.headers['x-client-type'] = 'web_app';

    if (token) {
        // add token to request headers
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
});

/* -------------------------------------------------------------------------------------------------
 * Response interceptor for transforming & handling errors
 * -----------------------------------------------------------------------------------------------*/

http.interceptors.response.use(
    (response) => {
        const version = getBuildVersion() || '0';

        const respAppVersion = response.headers['x-app-build-version'];

        if (respAppVersion !== version) {
            // Update version
            setBuildVersion(respAppVersion);

            // Set version update flag so we can refresh app later
            setBuildUpdateFlag(true);
        }

        return response;
    },
    (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                store.dispatch(authActions.logout());
                // toast.error(error?.response?.data?.message || 'You have been logged out.')
            }

            return Promise.reject(error.response);
        } else {
            return Promise.reject(error);
        }
    }
);

export default http;
